<template>
  <div id="cam">
    <div class="container">
      <!-- Container -->
      <div class="section-title text-center center zeropadding">
        <h2>{{ $t("index.cam") }}</h2>
        <div class="line">
          <hr />
        </div>
        <div class="clearfix"></div>
        <small
          ><em>{{ $t("index.camin") }}</em></small
        >
      </div>
      <div class="space"></div>

      <a-skeleton active :loading="loading4" v-if="pointShow">
        <div class="card">
          <div class="card-head">
            <div>{{ $t("index.exchange") }}</div>
          </div>
          <div class="card-content">
            <a-table :dataSource="dataSource" :columns="columns">
              <template #bodyCell="{ column, record }">
                <template v-if="column.dataIndex === 'action'">
                  <a @click="exchange(record.special)">{{ $t("index.exchangebtn") }}</a>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </a-skeleton>

      <a-skeleton active :loading="loading2" v-if="tubeShow || sheetShow">
        <div class="card">
          <div class="card-head">
            <div>{{ $t("index.myCam") }}</div>
          </div>
          <div class="card-content">
            <div class="softwarebox" v-if="tubeShow">
              <a-descriptions title="BodorNest Tube" bordered>
                <a-descriptions-item :label="$t('index.camInfo1')"
                  >838249</a-descriptions-item
                >
                <a-descriptions-item :label="$t('index.camInfo2')" :span="2"
                  >BodorNest Tube</a-descriptions-item
                >

                <a-descriptions-item :label="$t('index.camInfo3')">{{
                  tube.startTime
                }}</a-descriptions-item>
                <a-descriptions-item :label="$t('index.camInfo4')">{{
                  tube.endTime
                }}</a-descriptions-item>
                <a-descriptions-item :label="$t('index.camInfo5')">{{
                  tube.expiredTime
                }}</a-descriptions-item>

                <a-descriptions-item :label="$t('index.camInfo6')">{{
                  tube.startTime
                }}</a-descriptions-item>
                <a-descriptions-item :label="$t('index.camInfo7')">{{
                  tube.creationtime
                }}</a-descriptions-item>
                <a-descriptions-item :label="$t('index.camInfo8')">{{
                  tube.version
                }}</a-descriptions-item>
              </a-descriptions>
            </div>

            <div class="softwarebox" v-if="sheetShow">
              <a-descriptions title="BodorNest" bordered>
                <a-descriptions-item :label="$t('index.camInfo1')"
                  >250626</a-descriptions-item
                >
                <a-descriptions-item :label="$t('index.camInfo2')" :span="2"
                  >BodorNest</a-descriptions-item
                >

                <a-descriptions-item :label="$t('index.camInfo3')">{{
                  sheet.startTime
                }}</a-descriptions-item>
                <a-descriptions-item :label="$t('index.camInfo4')">{{
                  sheet.endTime
                }}</a-descriptions-item>
                <a-descriptions-item :label="$t('index.camInfo5')">{{
                  sheet.expiredTime
                }}</a-descriptions-item>

                <a-descriptions-item :label="$t('index.camInfo6')">{{
                  sheet.startTime
                }}</a-descriptions-item>
                <a-descriptions-item :label="$t('index.camInfo7')">{{
                  sheet.creationtime
                }}</a-descriptions-item>
                <a-descriptions-item :label="$t('index.camInfo8')">{{
                  sheet.version
                }}</a-descriptions-item>
              </a-descriptions>
            </div>
          </div>
        </div>
      </a-skeleton>

      <a-skeleton active :loading="loading1">
        <div class="card">
          <div class="card-head">
            <div>BodorNest Tube V1.0{{ $t("home.tubein") }}</div>
            <div>{{ $t("index.downloadInfo2") }}</div>
          </div>
          <div class="card-content">
            <div class="info">
              <img
                class="fileicon"
                :title="softWare.fileurl"
                :src="imgsUrl"
                alt="文件"
                @click="download1"
              />
              <div class="verticalline"></div>
              <div class="infocontent">
                <div class="infoitems">
                  <div class="infotitle">{{ $t("index.softwareName") }}</div>
                  <div class="infonumber" :title="softWare.filename">
                    {{ softWare.filename }}
                  </div>
                </div>
                <div class="infoitems">
                  <div class="infotitle">{{ $t("index.softwareAuthor") }}</div>
                  <div class="infonumber" :title="softWare.type">
                    {{ softWare.type }}
                  </div>
                </div>
                <div class="infoitems">
                  <div class="infotitle">{{ $t("index.newVersion") }}</div>
                  <div class="infonumber" :title="softWare.versionnumber">
                    {{ softWare.versionnumber }}
                  </div>
                </div>
                <div class="infoitems">
                  <div class="infotitle">{{ $t("index.updateTime") }}</div>
                  <div class="infonumber" :title="softWare.createtime">
                    {{ softWare.createtime }}
                  </div>
                </div>
              </div>
              <div class="verticalline"></div>
              <div class="btngroup">
                <a-button class="noradius" @click="download('bodornesttube')">{{
                  $t("home.download")
                }}</a-button>
                <a-button class="noradius" @click="video('tubevideo')">{{
                  $t("home.video")
                }}</a-button>
              </div>
            </div>
            <div class="introduct">
              <a-collapse v-model:activeKey="activeKey" :bordered="false">
                <template #expandIcon="{ isActive }">
                  <caret-right-outlined :rotate="isActive ? 90 : 0" />
                </template>
                <a-collapse-panel
                  key="1"
                  :header="$t('index.launch')"
                  class="customstyle"
                >
                  <pre class="artticle">{{ softWare.remark }}</pre>
                  <!--                 <a-typography></a-typography> -->
                </a-collapse-panel>
              </a-collapse>
            </div>
          </div>
        </div>
      </a-skeleton>

      <a-skeleton active :loading="loading5">
        <div class="card">
          <div class="card-head">
            <div>BodorNest Tube V1.5</div>
            <div>{{ $t("index.downloadInfo2") }}</div>
          </div>
          <div class="card-content">
            <div class="info">
              <img
                class="fileicon"
                :title="softWare3.fileurl"
                :src="imgsUrl"
                alt="文件"
                @click="download3"
              />
              <div class="verticalline"></div>
              <div class="infocontent">
                <div class="infoitems">
                  <div class="infotitle">{{ $t("index.softwareName") }}</div>
                  <div class="infonumber" :title="softWare3.filename">
                    {{ softWare3.filename }}
                  </div>
                </div>
                <div class="infoitems">
                  <div class="infotitle">{{ $t("index.softwareAuthor") }}</div>
                  <div class="infonumber" :title="softWare3.type">
                    {{ softWare3.type }}
                  </div>
                </div>
                <div class="infoitems">
                  <div class="infotitle">{{ $t("index.newVersion") }}</div>
                  <div class="infonumber" :title="softWare3.versionnumber">
                    {{ softWare3.versionnumber }}
                  </div>
                </div>
                <div class="infoitems">
                  <div class="infotitle">{{ $t("index.updateTime") }}</div>
                  <div class="infonumber" :title="softWare3.createtime">
                    {{ softWare3.createtime }}
                  </div>
                </div>
              </div>
              <div class="verticalline"></div>
              <div class="btngroup">
                <a-button class="noradius" @click="download('bodornest1.5')">{{
                  $t("home.download")
                }}</a-button>
                <a-button class="noradius" @click="video('1.5video')">{{
                  $t("home.video")
                }}</a-button>
              </div>
            </div>
            <div class="introduct">
              <a-collapse v-model:activeKey="activeKey" :bordered="false">
                <template #expandIcon="{ isActive }">
                  <caret-right-outlined :rotate="isActive ? 90 : 0" />
                </template>
                <a-collapse-panel
                  key="3"
                  :header="$t('index.launch')"
                  class="customstyle"
                >
                  <pre class="artticle">{{ softWare3.remark }}</pre>
                </a-collapse-panel>
              </a-collapse>
            </div>
          </div>
        </div>
      </a-skeleton>

      <a-skeleton active :loading="loading3">
        <div class="card">
          <div class="card-head">
            <div>BodorNest{{ $t("home.nestin") }}</div>
            <div>{{ $t("index.downloadInfo2") }}</div>
          </div>
          <div class="card-content">
            <div class="info">
              <img
                class="fileicon"
                :title="softWare2.fileurl"
                :src="imgsUrl"
                alt="文件"
                @click="download2"
              />
              <div class="verticalline"></div>
              <div class="infocontent">
                <div class="infoitems">
                  <div class="infotitle">{{ $t("index.softwareName") }}</div>
                  <div class="infonumber" :title="softWare2.filename">
                    {{ softWare2.filename }}
                  </div>
                </div>
                <div class="infoitems">
                  <div class="infotitle">{{ $t("index.softwareAuthor") }}</div>
                  <div class="infonumber" :title="softWare2.type">
                    {{ softWare2.type }}
                  </div>
                </div>
                <div class="infoitems">
                  <div class="infotitle">{{ $t("index.newVersion") }}</div>
                  <div class="infonumber" :title="softWare2.versionnumber">
                    {{ softWare2.versionnumber }}
                  </div>
                </div>
                <div class="infoitems">
                  <div class="infotitle">{{ $t("index.updateTime") }}</div>
                  <div class="infonumber" :title="softWare2.createtime">
                    {{ softWare2.createtime }}
                  </div>
                </div>
              </div>
              <div class="verticalline"></div>
              <div class="btngroup">
                <a-button class="noradius" @click="download('bodornest')">{{
                  $t("home.download")
                }}</a-button>
                <a-button class="noradius" @click="video('nestvideo')">{{
                  $t("home.video")
                }}</a-button>
              </div>
            </div>
            <div class="introduct">
              <a-collapse v-model:activeKey="activeKey" :bordered="false">
                <template #expandIcon="{ isActive }">
                  <caret-right-outlined :rotate="isActive ? 90 : 0" />
                </template>
                <a-collapse-panel
                  key="2"
                  :header="$t('index.launch')"
                  class="customstyle"
                >
                  <pre class="artticle">{{ softWare2.remark }}</pre>
                </a-collapse-panel>
              </a-collapse>
            </div>
          </div>
        </div>
      </a-skeleton>

      <a-drawer
        :title="t('index.accountConfirm')"
        :width="400"
        :open="open"
        :body-style="{ paddingBottom: '80px' }"
        :footer-style="{ textAlign: 'right' }"
        @close="onClose"
      >
        <a-form :model="form" :rules="rules" layout="vertical">
          <a-row :gutter="16">
            <a-col :span="24">
              <a-form-item :label="t('index.name')" name="name">
                <a-input v-model:value="form.name" :placeholder="t('index.namein')" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="24">
              <a-form-item :label="t('index.account')" name="account">
                <a-input
                  v-model:value="form.account"
                  :placeholder="t('index.accountin')"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <template #extra>
          <a-space>
            <a-button @click="onClose">{{ $t("index.cancel") }}</a-button>
            <a-button type="primary" @click="onSubmit" :loading="submitLoading">{{
              $t("index.submit")
            }}</a-button>
          </a-space>
        </template>
      </a-drawer>
    </div>
  </div>
</template>

<script setup>
import { ref, h } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import { CaretRightOutlined } from "@ant-design/icons-vue";
import { message, Modal } from "ant-design-vue";
import { useI18n } from "vue-i18n";
import { required } from "@/utils/formRules";

const { t } = useI18n();

let router = useRouter();
const softWare = ref({});
const softWare2 = ref({});
const softWare3 = ref({});
const tube = ref({});
const sheet = ref({});

localStorage.setItem("router", "cam");

const imgsUrl = ref(require("@/assets/img/device/file.png"));

const activeKey = ref([]);
const loading1 = ref(false);
const loading2 = ref(false);
const loading3 = ref(false);
const loading4 = ref(false);
const loading5 = ref(false);

const pointShow = ref(false);
const sheetShow = ref(false);
const tubeShow = ref(false);
const dataSource = ref([]);
const submitLoading = ref(false);

const form = ref({
  name: "",
  account: "",
});
const rules = {
  name: [required(t("index.namein"))],
  account: [required(t("index.accountin"))],
};

const columns = [
  {
    title: t("index.exchangetb1"),
    dataIndex: "title",
  },
  {
    title: t("index.exchangetb2"),
    dataIndex: "point1",
  },
  {
    title: t("index.exchangetb3"),
    dataIndex: "point2",
  },
  {
    title: t("index.exchangetb4"),
    dataIndex: "preferential",
  },
  {
    title: t("index.exchangetb5"),
    dataIndex: "action",
    align: "center",
    width: "100px",
  },
];
let nestTab = {
  title: "BodorNest老用户专享板切套料软件 3个月使用时间（当前许可到期前7天内兑换）",
  point1: "3000积分",
  point2: "300积分",
  preferential: "90%",
  special: "250626",
};
let tubeTab = {
  title: "BodorNest Tube老用户专享管切套料软件 3个月使用时间（当前许可到期前7天内兑换）",
  point1: "3000积分",
  point2: "300积分",
  preferential: "90%",
  special: "838249",
};
let useremail = "";
let IsSheetOldUser = "0";
let IsTubeOldUser = "0";
var vkeyWords = /@bodor.com$/;
var vkeyWordscc = /@bodor.cc/;
const open = ref(false);
let BlicenseId = "";
const showDrawer = (licenseId) => {
  open.value = true;
  BlicenseId = licenseId;
};
const onClose = () => {
  open.value = false;
  form.value = {
    name: "",
    account: "",
  };
};

const isEmail = ref(false);
let user = JSON.parse(localStorage.getItem("user"));
if (user.Email) {
  isEmail.value = true;
}

if (!isEmail.value) {
  Modal.confirm({
    title: t("index.noEmail"),
    content: h("div", {}, [h("p", t("index.noEmailin"))]),
    cancelText: t("index.notNow"),
    okText: t("index.emailNow"),
    onOk() {
      router.push(`/usercenter`);
    },
    onCancel() {},
  });
}

loading1.value = true;
axios
  .post("/api/Cam/GetCamAssistant", {
    ProductType: "0",
  })
  .then((response) => {
    if (response.data.ReturnData.length > 0) {
      softWare.value = response.data.ReturnData[0];
      softWare.value.fileurl = "https://apicloud.bodor.com" + softWare.value.fileurl;
    } else {
      message.error(response.data.ReturnMsg);
    }
  })
  .catch((error) => {
    console.error(error);
  })
  .finally(() => {
    loading1.value = false;
  });

loading5.value = true;
axios
  .post("/api/Cam/GetCamAssistant", {
    ProductType: "2",
  })
  .then((response) => {
    if (response.data.ReturnData.length > 0) {
      softWare3.value = response.data.ReturnData[0];
      softWare3.value.fileurl = "https://apicloud.bodor.com" + softWare3.value.fileurl;
    } else {
      message.error(response.data.ReturnMsg);
    }
  })
  .catch((error) => {
    console.error(error);
  })
  .finally(() => {
    loading5.value = false;
  });

loading3.value = true;
axios
  .post("/api/Cam/GetCamAssistant", {
    ProductType: "1",
  })
  .then((response) => {
    if (response.data.ReturnData.length > 0) {
      softWare2.value = response.data.ReturnData[0];
      softWare2.value.fileurl = "https://apicloud.bodor.com" + softWare2.value.fileurl;
    } else {
      message.error(response.data.ReturnMsg);
    }
  })
  .catch((error) => {
    console.error(error);
  })
  .finally(() => {
    loading3.value = false;
  });

const formattedTimestamp = (time) => {
  const date = new Date(time * 1000); // 时间戳需要转换为毫秒
  return `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(
    date.getDate()
  )} ${padZero(date.getHours())}:${padZero(date.getMinutes())}:${padZero(
    date.getSeconds()
  )}`;
};

function padZero(value) {
  return String(value).padStart(2, "0");
}

loading2.value = true;
/* loading4.value = true; */
axios
  .post("/api/Cam/USERWEBgetuserdogPageList", {
    LicenseId: "838249",
  })
  .then((response) => {
    console.log("response 流程1：", response);
    if (response.data.code != 200 && response.data.info != "暂无数据") {
      message.error(response.data.info);
    } else if (response.data.info == "暂无数据") {
      message.warn(t("index.camWarn"));
    } else {
      console.log("response：", response.data);
      useremail = response.data.ReturnData[0].useremail;
      IsTubeOldUser = response.data.ReturnData[0].IsOldUser;
      console.log("useremail:", useremail);
      if (
        IsTubeOldUser == "1" ||
        vkeyWords.test(useremail) ||
        vkeyWordscc.test(useremail)
      ) {
        pointShow.value = true;
        dataSource.value.push(tubeTab);
      }
      JSON.parse(response.data.info).data.licenses.forEach((data) => {
        if (data.licenseId == 838249) {
          // 管
          tube.value = data;
          tube.value.startTime = formattedTimestamp(data.startTime);
          tube.value.endTime = formattedTimestamp(data.endTime);
          tube.value.expiredTime = formattedTimestamp(data.expiredTime);
          tube.value.firstUseTime = formattedTimestamp(data.firstUseTime);
          tube.value.creationtime = response.data.ReturnData[0].creationtime;
          tube.value.version = response.data.ReturnData[0].version;

          tubeShow.value = true;
        }
      });
    }
  })
  .catch((error) => {
    console.error(error);
  })
  .finally(() => {
    loading2.value = false;
    loading4.value = false;
  });

loading2.value = true;
axios
  .post("/api/Cam/USERWEBgetuserdogPageList", {
    LicenseId: "250626",
  })
  .then((response) => {
    console.log("流程1", response);
    if (response.data.code != 200 && response.data.info != "暂无数据") {
      message.error(response.data.info);
    } else if (response.data.info == "暂无数据") {
      message.warn(t("index.camWarn"));
    } else {
      console.log("流程2", response.data);
      useremail = response.data.ReturnData[0].useremail;
      IsSheetOldUser = response.data.ReturnData[0].IsOldUser;
      console.log("流程3:", IsSheetOldUser);
      if (
        IsSheetOldUser == "1" ||
        vkeyWords.test(useremail) ||
        vkeyWordscc.test(useremail)
      ) {
        console.log("流程4");
        pointShow.value = true;
        dataSource.value.push(nestTab);
      }
      JSON.parse(response.data.info).data.licenses.forEach((data) => {
        if (data.licenseId == 250626) {
          // 板
          sheet.value = data;
          sheet.value.startTime = formattedTimestamp(data.startTime);
          sheet.value.endTime = formattedTimestamp(data.endTime);
          sheet.value.expiredTime = formattedTimestamp(data.expiredTime);
          sheet.value.firstUseTime = formattedTimestamp(data.firstUseTime);
          sheet.value.creationtime = response.data.ReturnData[0].creationtime;
          sheet.value.version = response.data.ReturnData[0].version;

          sheetShow.value = true;
        }
      });
    }
  })
  .catch((error) => {
    console.error(error);
  })
  .finally(() => {
    loading2.value = false;
    loading4.value = false;
  });

const version = () => {};

const environment = () => {};

const history = () => {};

const instructions = () => {};

const onSubmit = () => {
  if (form.value.account != "" && form.value.name != "") {
    submitLoading.value = true;
    axios
      .post("api/Cam/IsBodorUser", {
        Account: form.value.account,
        RealName: form.value.name,
      })
      .then((response) => {
        if (response.data.code != 200) {
          message.error(response.data.info);
        } else {
          message.success(t("index.jobSuccess"));
          onClose();
          exchange2();
        }
      })
      .finally(() => {
        submitLoading.value = false;
      });
  } else {
    message.error(t("index.jobErr"));
  }
};

const exchange = (licenseId) => {
  if (vkeyWords.test(useremail) || vkeyWordscc.test(useremail)) {
    showDrawer(licenseId);
  } else {
    exchange2(licenseId);
  }
};

const exchange2 = (licenseId) => {
  if (!licenseId) {
    licenseId = BlicenseId;
  }
  axios
    .post("api/Cam/OldUserPointExchange", {
      LicenseId: licenseId,
    })
    .then((response) => {
      if (response.data.code != 200) {
        message.error(response.data.info);
      } else {
        message.success(t("index.exchangeSuccess"));
      }
    });
};

const video = (type) => {
  if (type == "tubevideo" || type == "1.5video") {
    message.info("暂无视频");
  } else {
    router.push(`/${type}`);
  }
};

function download(type) {
  router.push(`/${type}/false`);
}

const download1 = () => {
  let link = document.createElement("a");
  //创建一个a标签
  link.style.display = "none";
  //将a标签隐藏
  link.href = softWare.value.fileurl;
  //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
  link.setAttribute("download", softWare.value.filename);
  // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
  document.body.appendChild(link);
  //将上面创建的a标签加入到body的尾部
  link.click();
  axios
    .post("/api/Cam/InsertDownload", {
      CamEdition: softWare.value.id,
    })
    .then((response) => {
      if (response.data.code != 200) {
        message.error(response.data.info);
      }
    })
    .catch((error) => {
      console.error(error);
    });
};

const download2 = () => {
  let link = document.createElement("a");
  //创建一个a标签
  link.style.display = "none";
  //将a标签隐藏
  link.href = softWare2.value.fileurl;
  //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
  link.setAttribute("download", softWare2.value.filename);
  // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
  document.body.appendChild(link);
  //将上面创建的a标签加入到body的尾部
  link.click();
  axios
    .post("/api/Cam/InsertDownload", {
      CamEdition: softWare2.value.id,
    })
    .then((response) => {
      if (response.data.code != 200) {
        message.error(response.data.info);
      }
    })
    .catch((error) => {
      console.error(error);
    });
};

const download3 = () => {
  let link = document.createElement("a");
  //创建一个a标签
  link.style.display = "none";
  //将a标签隐藏
  link.href = softWare3.value.fileurl;
  //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
  link.setAttribute("download", softWare3.value.filename);
  // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
  document.body.appendChild(link);
  //将上面创建的a标签加入到body的尾部
  link.click();
  axios
    .post("/api/Cam/InsertDownload", {
      CamEdition: softWare3.value.id,
    })
    .then((response) => {
      if (response.data.code != 200) {
        message.error(response.data.info);
      }
    })
    .catch((error) => {
      console.error(error);
    });
};
</script>

<style scoped>
#cam {
  padding: 100px 0px;
  background-color: #f7f9fa;
}
.zeropadding {
  padding: 0px;
}
.card {
  box-sizing: border-box;
  border: none;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  margin: 20px 0px;
  overflow: visible;
  transition: all 0.4s;
  font-size: 14px;
  background-color: white;
}
.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.card-head {
  width: 100%;
  align-items: center;
  color: #333;
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
}
.card-content {
  width: 100%;
  min-height: 50px;
  padding: 15px;
  display: flex;
  flex-direction: column;
}
.info {
  display: flex;
  justify-content: space-between;
}
.introduct {
  margin-top: 40px;
}
.fileicon {
  width: 200px;
  height: 200px;
  margin: 0px 30px;
  cursor: pointer;
}
.verticalline {
  width: 1px;
  background-color: #e3e4e6;
  margin: 0px 30px;
}
.infocontent {
  flex-grow: 1;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
}
.infoitems {
  border-color: #c0c6cc;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  height: 80px;
  position: relative;
  text-align: left;
  border-radius: 4px;
  padding: 12px;
  width: 48%;
  text-decoration: none;
  background: #f7f9fa;
  border: 1px solid transparent;
  transition: all 0.1s linear;
}
.infoitems:hover {
  border-color: #c0c6cc;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
}
.infotitle {
  line-height: 18px;
  height: 18px;
  color: #555;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 18px;
  height: 18px;
}
.infonumber {
  display: block;
  line-height: 50px;
  height: 50px;
  font-size: 18px;
  font-weight: 500;
  color: #333;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.btngroup {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-right: 20px;
}
.noradius {
  border-radius: 0px;
}
.customstyle {
  background: #f7f9fa;
  border-radius: 4px;
  margin-bottom: 10px;
  overflow: hidden;
  border-color: #c0c6cc;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  border: 1px solid transparent;
  transition: all 0.1s linear;
}
.customstyle:hover {
  box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.softwarebox {
  margin-bottom: 20px;
}
.artticle {
  width: 100%;
  border: none;
  background-color: rgb(250, 250, 250);
  margin-bottom: 0px;
  font-family: Menlo, Monaco, Consolas, -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
a {
  color: #1890ff;
}
</style>
